import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfirmationService, MessageService, SortEvent } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { AtividadeEconomicaDTO, AtividadeEconomicaFormDTO } from '../../../../models/configuracoes/atividade-economica.model';
import { AtividadeEconomicaService } from '../../../../services/configuracoes/atividade-economica.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-atividade-economica-edit',
    templateUrl: './configuracao-atividade-economica-edit.component.html',
    styleUrls: ['./configuracao-atividade-economica-edit.component.scss'],
    providers: [ConfirmationService, MessageService],
})
export class AtividadeEconomicaEditComponent implements OnInit, OnDestroy {
    checked = false;
    date2: Date | undefined;
    atividades: AtividadeEconomicaDTO[] = [];
    first3 = 0;
    rows3 = 5;
    totalRecords = 0;
    lastfield = '';
    lastSort = '';
    options = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 120, value: 120 },
    ];
    form: AtividadeEconomicaFormDTO = this.createEmptyForm();

    texts = { titulo: '' };
    labels = { nome: '', codigo: '' };
    placeholders = { nome: '', codigo: '' };
    botoes = { enviar: '' };

    private langChangeSub!: Subscription;

    constructor(
        private messageService: MessageService,
        private atividadeEconomicaService: AtividadeEconomicaService,
        private router: Router,
        private route: ActivatedRoute,
        private translate: TranslateService
    ) {}

    ngOnInit() {
        this.loadTranslations();
        this.langChangeSub = this.translate.onLangChange.subscribe(() => {
            this.loadTranslations();
        });

        const id = this.route.snapshot.paramMap.get('id');
        if (id) {
            this.atividadeEconomicaService.getById('/atividadeEconomica/' + id).subscribe((response) => {
                this.form = {
                    id: response.id,
                    codigo: response.codigo,
                    nome: response.nome,
                };
            });
        }
    }
    submit() {
        if (this.form.nome === '') {
            this.messageService.add({ severity: 'error', summary: this.translate.instant('common.erro'), detail: this.translate.instant('atividade-economica-edit.mensagens.nome_obrigatorio') });
            return;
        }

        if (this.form.codigo === undefined) {
            this.messageService.add({ severity: 'error', summary: this.translate.instant('common.erro'), detail: this.translate.instant('atividade-economica-edit.mensagens.codigo_obrigatorio') });
            return;
        }

        const body: AtividadeEconomicaDTO = {
            nome: this.form.nome,
            codigo: this.form.codigo
        }

        this.atividadeEconomicaService.put("/atividadeEconomica/"+ this.form.id, body).subscribe({
            next: (response) => {
                this.messageService.add({
                    severity: 'success',
                    summary: this.translate.instant('common.sucesso'),
                    detail: this.translate.instant('atividade-economica-edit.mensagens.editada_sucesso')
                });
                this.form = this.createEmptyForm();
                this.router.navigate(['/configuracao-atividade-economica']);
            },
            error: (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: this.translate.instant('common.erro'),
                    detail: this.translate.instant('atividade-economica-edit.mensagens.falha_salvar')
                });
            }
        });
    }

    ngOnDestroy(): void {
        if (this.langChangeSub) {
            this.langChangeSub.unsubscribe();
        }
    }

    private loadTranslations(): void {
        this.texts = {
            titulo: this.translate.instant('configuracao-atividade-economica-edit.texts.add_nova_atividade_economica')
        };
        this.labels = {
            nome: this.translate.instant('configuracao-atividade-economica-edit.labels.nome'),
            codigo: this.translate.instant('configuracao-atividade-economica-edit.labels.codigo')
        };
        this.placeholders = {
            nome: this.translate.instant('configuracao-atividade-economica-edit.placeholders.nome_do_estado'),
            codigo: this.translate.instant('configuracao-atividade-economica-edit.placeholders.codigo_fatura_eletronica')
        };
        this.botoes = {
            enviar: this.translate.instant('configuracao-atividade-economica-edit.botoes.enviar')
        };
    }

    createEmptyForm(): AtividadeEconomicaFormDTO {
        return {
            nome: '',
            codigo: ''
        };
    }
}
